import * as m from "mithril";
import { MessageProvider } from '../../../context/AppMessages';
import '../TripResultList.scss';
import { Dialog } from '../../../components/MaterialDesignComponents';
import Stars from '../../../components/Stars';
import { InternationalStringDTO, OperatorDTO, OperatorRatingSummaryDTO, TripDTO, TripResultDTO, WayPointScheduleDTO } from "../../../apiclient/ApiDtos";
import SearchCriteria from "../../../models/SearchCriteria";
import dayjs = require("dayjs");
import { TripGroupComponent } from "./TripGroup";

export interface TripGroup {
    [groupId: string]: {
        operator: OperatorDTO;
        busType: InternationalStringDTO;
        summary: TripResultDTO;
        trips: Record<WayPointScheduleDTO["scheduledAt"], TripDTO[]>;
    };
}

type TripsByOperator = Record<OperatorDTO["id"], TripDTO[]>;

interface Attrs {
    id: string,
    searchCriteria: SearchCriteria,
    tripResults: TripDTO[],
    messageProvider: MessageProvider,
    onViewSeatButtonClick: (res) => void
    onViewOperatorPhotosButtonClick: (result) => void
}

function SmallCarTripResultList(): m.Component<Attrs> {
    let currentRatingSummary: OperatorRatingSummaryDTO | null = null;

    return {
        view(vnode) {
            const tripGroup: TripGroup = vnode.attrs.tripResults.reduce((group, trip) => {
                const customGroupId = trip.operator.id + trip.busType.en + trip.busType.my 
                + trip.priceRange.min.amount + trip.priceRange.min.currency + trip.priceRange.max.amount;
                const schedule = trip.departure.scheduledAt;

                if (!group[customGroupId]) {
                    group[customGroupId] = {
                        operator: trip.operator,
                        busType: trip.busType,
                        summary: trip,
                        trips: {}
                    };
                }

                if (!group[customGroupId].trips[schedule]) {
                    group[customGroupId].trips[schedule] = [];
                }

                group[customGroupId].trips[schedule].push(trip);

                return group;
            }, {} as TripGroup);

            return [
                m("div", { class: 'pr-0 pl-0 pb-2 pt-0 mb-2', id: vnode.attrs.id }, [
                    (currentRatingSummary) ?
                        m(Dialog, {
                            title: "Rating Summary",
                            isOpen: currentRatingSummary != null,
                            onClose: () => {
                                currentRatingSummary = null;
                            },
                            actionItems: [
                                {
                                    label: "Ok",
                                    onclick: () => {
                                        currentRatingSummary = null;
                                    }
                                }
                            ]
                        }, [
                            m("table.table table-stripped", [
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_discipline")),
                                    m("td", m(Stars, { value: currentRatingSummary.driverBehavior }))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_comfort")),
                                    m("td", m(Stars, { value: currentRatingSummary.seatComfortableness }))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_cleanliness")),
                                    m("td", m(Stars, { value: currentRatingSummary.cleanliness }))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_service")),
                                    m("td", m(Stars, { value: currentRatingSummary.staffHelpfulness }))
                                ]),
                                m("tr", [
                                    m("td", vnode.attrs.messageProvider.get("feedback_driver_punctuality")),
                                    m("td", m(Stars, { value: currentRatingSummary.punctuality }))
                                ]),
                            ])
                        ]) : null,

                    (vnode.attrs.tripResults.length == 0) ?
                        m("div", { class: "pt-5 px-3" }, [
                            m("h5", { class: "text-center font-weight-bold" }, vnode.attrs.messageProvider.get("message.no_small_car_trip_available")),
                            m("div", { class: "text-center text-muted font-italic_ mb-4" }, vnode.attrs.messageProvider.get("message.change_date_or_route"))
                        ])
                        : null,

                    Object.values(tripGroup).map(function (group) {
                        return m(TripGroupComponent, {
                            messageProvider: vnode.attrs.messageProvider,
                            tripGroup: group,
                            searCriteria: vnode.attrs.searchCriteria,
                            onViewSeatButtonClick: (result) => {
                                vnode.attrs.onViewSeatButtonClick(result);
                            },
                            onViewOperatorPhotosButtonClick: function (result) {
                                vnode.attrs.onViewOperatorPhotosButtonClick(result)
                            },
                            onRatingSummaryClick: (ratingSummary) => {
                                currentRatingSummary = ratingSummary;
                            }
                        })
                    })
                ]),
            ];
        }
    }
};

export default SmallCarTripResultList;